import React, { useState, useEffect, useRef } from "react";

interface City {
  name: string;
  comingSoon?: boolean;
}

const CITIES: City[] = [
  { name: "San Diego" },
  { name: "Los Angeles", comingSoon: true },
];

function PinIcon(): React.ReactElement {
  return (
    <svg
      viewBox="0 0 24 24"
      width="13"
      height="13"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 21s-6.5-6-6.5-11a6.5 6.5 0 0 1 13 0c0 5-6.5 11-6.5 11Z" />
      <circle cx="12" cy="10" r="2.2" />
    </svg>
  );
}

function ChevIcon(): React.ReactElement {
  return (
    <svg
      viewBox="0 0 24 24"
      width="14"
      height="14"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="6 9 12 15 18 9" />
    </svg>
  );
}

function TickIcon(): React.ReactElement {
  return (
    <svg
      viewBox="0 0 24 24"
      width="14"
      height="14"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="4 12 10 18 20 6" />
    </svg>
  );
}

interface LocationSelectorProps {
  value: string;
  onChange: (city: string) => void;
}

export function LocationSelector({
  value,
  onChange,
}: LocationSelectorProps): React.ReactElement {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function onDoc(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node))
        setOpen(false);
    }
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  return (
    <div className="loc" ref={ref}>
      <button
        className={"loc-btn" + (open ? " open" : "")}
        onClick={() => setOpen((o) => !o)}
      >
        <span className="pin">
          <PinIcon />
        </span>
        {value}
        <span className="chev">
          <ChevIcon />
        </span>
      </button>
      {open && (
        <div className="loc-menu">
          {CITIES.map((c) => (
            <button
              key={c.name}
              className={
                "loc-opt" +
                (c.name === value ? " active" : "") +
                (c.comingSoon ? " soon" : "")
              }
              disabled={c.comingSoon}
              onClick={() => {
                if (c.comingSoon) return;
                onChange(c.name);
                setOpen(false);
              }}
            >
              {c.comingSoon ? `${c.name} (coming soon)` : c.name}
              {!c.comingSoon && (
                <span className="tick">
                  <TickIcon />
                </span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
